import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class HolidayAllowanceService extends Service {
	constructor(injector: Injector) {
		super("HolidayAllowance", injector);
	}

	// API
	createAllowancesForYear(year: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CreateAllowancesForYear/${year}`, {});
	}

	myAllowanceForYear(year: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/MyAllowanceForYear/${year}`);
	}
}